<div class="preloader" id="loader" style="
    background-image: url('assets/img/preloader.gif');
    position: fixed;
    display: none;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 999999;
    background-color: rgb(255, 255, 255);
    background-position: center center;
    background-repeat: no-repeat;
    overflow: hidden;
"></div>

<main class="survey-main">
  <div class="survey-wrapper">
    <form [formGroup]="productForm" (ngSubmit)="Submit()">

      <!-- Header Info Card -->
      <div class="survey-header-card">
        <div class="survey-header-title">
          <i class="fa fa-car"></i>
          <span>Motor Survey</span>
        </div>
        <div class="survey-meta-badges">
          <div class="meta-badge">
            <span class="meta-label">Claim ID</span>
            <span class="meta-value">{{ EditForm?.inspection_id || '—' }}</span>
          </div>
          <div class="meta-badge">
            <span class="meta-label">Insured</span>
            <span class="meta-value">{{ EditForm?.insured_name || '—' }}</span>
          </div>
          <div class="meta-badge">
            <span class="meta-label">Reg. No.</span>
            <span class="meta-value">{{ EditForm?.vehicle_reg_no || '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Vehicle Images Section -->
      <div class="survey-section-card">
        <div class="section-header">
          <div class="section-title">
            <i class="fa fa-image"></i>
            <span>Vehicle Images</span>
          </div>
        </div>

        <div cdkDropList class="example-list image-grid image-grid--media" (cdkDropListDropped)="drop($event)" formArrayName="form_field">
          <ng-container *ngFor="let item of formFieldArray().controls; let i = index">
            <div [formGroupName]="i" class="image-card-wrap" *ngIf="item.controls.form_field_label">
              <div class="image-card image-card--vehicle">
                <div class="image-card-remove" *ngIf="EditActive && ImageArray[i].form_field_label.custom"
                  (click)="removeQuantity(i)" title="Remove">
                  <i class="fa fa-times"></i>
                </div>
                <input
                  type="file"
                  accept="image/*"
                  [attr.capture]="capture"
                  class="d-none"
                  (change)="fileChange($event, i, 'form_field_label', item.controls.form_field_label)"
                  id="form_field_label{{ i }}" />
                <label class="image-card-label" for="form_field_label{{ i }}">
                  <div
                    class="image-card-thumb"
                    [class.image-card-thumb--empty]="isPlaceholderSrc(ImageArray[i].form_field_label.src)">
                    <img
                      *ngIf="!isPlaceholderSrc(ImageArray[i].form_field_label.src)"
                      [src]="ImageArray[i].form_field_label.src"
                      alt="" />
                    <div class="image-thumb-placeholder-deco" *ngIf="isPlaceholderSrc(ImageArray[i].form_field_label.src)" aria-hidden="true">
                      <span class="image-thumb-placeholder-ring"></span>
                      <i class="fa fa-picture-o"></i>
                    </div>
                    <div class="image-upload-overlay image-upload-overlay--vehicle" *ngIf="isPlaceholderSrc(ImageArray[i].form_field_label.src)">
                      <i class="fa fa-image"></i>
                      <span>Tap to upload image</span>
                    </div>
                  </div>
                </label>
                <input type="hidden" formControlName="form_field_label" />
                <span class="field-error"
                  *ngIf="(item.controls.form_field_label.touched || submitted) && item.controls.form_field_label.errors?.required">
                  Required
                </span>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="section-add-control section-add-control--bottom" *ngIf="EditActive">
          <input
            type="file"
            accept="image/*"
            [attr.capture]="capture"
            class="d-none"
            (change)="onAddImageFieldChange($event)"
            id="addImageFieldInput" />
          <label for="addImageFieldInput" class="btn btn-add">
            <i class="fa fa-plus"></i> Click Vehicle Image
          </label>
        </div>

      </div>

      <!-- Vehicle Documents Section -->
      <div class="survey-section-card">
        <div class="section-header">
          <div class="section-title">
            <i class="fa fa-file-text-o"></i>
            <span>Vehicle Documents</span>
          </div>
        </div>

        <div class="image-grid image-grid--media" formArrayName="form_field">
          <ng-container *ngFor="let item of formFieldArray().controls; let i = index">
            <div [formGroupName]="i" class="image-card-wrap" *ngIf="item.controls.form_document_label">
              <div class="image-card image-card--document">
                <div class="image-card-remove" *ngIf="EditActive && ImageArray[i].form_document_label.custom"
                  (click)="removeQuantity(i)" title="Remove">
                  <i class="fa fa-times"></i>
                </div>
                <input
                  type="file"
                  accept="image/*"
                  [attr.capture]="capture"
                  class="d-none"
                  (change)="fileChange($event, i, 'form_document_label', item.controls.form_document_label)"
                  id="form_doc_label{{ i }}" />
                <label class="image-card-label" for="form_doc_label{{ i }}">
                  <div
                    class="image-card-thumb"
                    [class.image-card-thumb--empty]="isPlaceholderSrc(ImageArray[i].form_document_label.src)">
                    <img
                      *ngIf="!isPlaceholderSrc(ImageArray[i].form_document_label.src)"
                      [src]="ImageArray[i].form_document_label.src"
                      alt="" />
                    <div class="image-thumb-placeholder-deco image-thumb-placeholder-deco--doc" *ngIf="isPlaceholderSrc(ImageArray[i].form_document_label.src)" aria-hidden="true">
                      <span class="image-thumb-placeholder-ring image-thumb-placeholder-ring--doc"></span>
                      <i class="fa fa-file-text-o"></i>
                    </div>
                    <div class="image-upload-overlay image-upload-overlay--document" *ngIf="isPlaceholderSrc(ImageArray[i].form_document_label.src)">
                      <i class="fa fa-image"></i>
                      <span>Tap to upload image</span>
                    </div>
                  </div>
                </label>
                <input type="hidden" formControlName="form_document_label" />
                <span class="field-error"
                  *ngIf="(item.controls.form_document_label.touched || submitted) && item.controls.form_document_label.errors?.required">
                  Required
                </span>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="section-add-control section-add-control--bottom" *ngIf="EditActive">
          <input
            type="file"
            accept="image/*"
            [attr.capture]="capture"
            class="d-none"
            (change)="onAddDocumentFieldChange($event)"
            id="addDocumentFieldInput" />
          <label for="addDocumentFieldInput" class="btn btn-add">
            <i class="fa fa-plus"></i> Click Document image
          </label>
        </div>
      </div>

      <!-- Survey Video Section -->
      <div class="survey-section-card" *ngIf="isVideoActive">
        <div class="section-header">
          <div class="section-title">
            <i class="fa fa-video-camera"></i>
            <span>Survey Video</span>
          </div>
          <div class="video-duration-badge">
            <i class="fa fa-clock-o"></i>
            <span>Max 30 seconds</span>
          </div>
        </div>

        <div class="video-upload-container">
          <div class="video-upload-area" [class.video-upload-area--has-video]="videoPreview">
            <input
              type="file"
              formControlName="video_file"
              (change)="onFileChange($event)"
              accept="video/mp4,video/x-m4v,video/*"
              capture="camera"
              class="video-input"
              id="videoFileInput" />
            
            <label for="videoFileInput" class="video-upload-label">
              <div class="video-upload-content" *ngIf="!videoPreview">
                <div class="video-upload-icon">
                  <i class="fa fa-video-camera"></i>
                </div>
                <div class="video-upload-text">
                  <h4>Record Survey Video</h4>
                  <p>Click to browse or capture video</p>
                  <small class="text-muted">Supported formats: MP4, MOV, AVI (Max 30 seconds)</small>
                </div>
              </div>
              
              <div class="video-preview-container" *ngIf="videoPreview">
                <video [src]="videoPreview" class="video-preview" controls></video>
                <div class="video-preview-overlay">
                  <button type="button" class="btn btn-remove-video" (click)="removeVideo($event)">
                    <i class="fa fa-trash"></i>
                    Remove Video
                  </button>
                </div>
              </div>
            </label>
          </div>
          
         
        </div>

        <div class="video-upload-progress" *ngIf="videoUploading">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated" 
                 [style.width.%]="uploadProgress">
              {{ uploadProgress }}%
            </div>
          </div>
        </div>

        <span class="field-error" 
              *ngIf="(productForm.get('video_file')?.touched || submitted) && productForm.get('video_file')?.errors?.required">
          Video is required for survey completion
        </span>
        <span class="field-error" 
              *ngIf="videoDurationError">
          Video duration exceeds 30 seconds limit
        </span>
      </div>

      <!-- Job Remark Section -->
      <div class="survey-section-card">
        <div class="section-header">
          <div class="section-title">
            <i class="fa fa-pencil"></i>
            <span>Job Remark</span>
          </div>
        </div>
        <div class="remark-editor">
          <quill-editor [modules]="quillConfig" formControlName="job_remark" [placeholder]="'Enter job remark here...'">
          </quill-editor>
        </div>
      </div>

      <!-- Submit Section -->
      <div class="submit-section">
        <button type="submit" class="btn btn-submit">
          <i class="fa fa-paper-plane"></i>
          Submit Survey
        </button>
      </div>

    </form>
  </div>

  <!-- Modal -->
  <div bsModal #primaryModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: 'static', keyboard: false }">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content survey-modal-content">
        <div class="modal-body p-0">
          <div class="modal-close-bar">
            <button type="button" class="btn-modal-close" (click)="primaryModal.hide()" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-editor-wrap">
            <ng-container *ngIf="imageURL">
              <app-image-editor [inputImage]="imageURL"></app-image-editor>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
